/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
} from './OrganizationStateTown';

/**
 * 
 * @export
 * @interface CreateOrganizationStateTownsBulk201Response
 */
export interface CreateOrganizationStateTownsBulk201Response {
    /**
     * 
     * @type {Array<OrganizationStateTown>}
     * @memberof CreateOrganizationStateTownsBulk201Response
     */
    data?: Array<OrganizationStateTown>;
}

/**
 * Check if a given object implements the CreateOrganizationStateTownsBulk201Response interface.
 */
export function instanceOfCreateOrganizationStateTownsBulk201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateOrganizationStateTownsBulk201ResponseFromJSON(json: any): CreateOrganizationStateTownsBulk201Response {
    return CreateOrganizationStateTownsBulk201ResponseFromJSONTyped(json, false);
}

export function CreateOrganizationStateTownsBulk201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationStateTownsBulk201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(OrganizationStateTownFromJSON)),
    };
}

export function CreateOrganizationStateTownsBulk201ResponseToJSON(value?: CreateOrganizationStateTownsBulk201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(OrganizationStateTownToJSON)),
    };
}

